// Icon lookup for registry entries. The registry stays plain data (safe to
// filter/serialise/test); anything that needs a rendered icon resolves it
// here by key.
import React from 'react'
import HomeIcon from '@mui/icons-material/Home'
import InsightsIcon from '@mui/icons-material/Insights'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import EventIcon from '@mui/icons-material/Event'
import EventBusyIcon from '@mui/icons-material/EventBusy'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import SpeedIcon from '@mui/icons-material/Speed'
import Diversity3Icon from '@mui/icons-material/Diversity3'
import SchoolIcon from '@mui/icons-material/School'
import LocalPoliceIcon from '@mui/icons-material/LocalPolice'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import DvrIcon from '@mui/icons-material/Dvr'
import HubIcon from '@mui/icons-material/Hub'
import HotelIcon from '@mui/icons-material/Hotel'
import HandshakeIcon from '@mui/icons-material/Handshake'
import ScheduleIcon from '@mui/icons-material/Schedule'
import PunchClockIcon from '@mui/icons-material/PunchClock'
import PeopleIcon from '@mui/icons-material/People'
import BusinessIcon from '@mui/icons-material/Business'
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled'
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi'
import LocalCarWashIcon from '@mui/icons-material/LocalCarWash'
import BuildIcon from '@mui/icons-material/Build'
import InventoryIcon from '@mui/icons-material/Inventory'
import ChecklistIcon from '@mui/icons-material/Checklist'
import NoCrashIcon from '@mui/icons-material/NoCrash'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation'
import RuleIcon from '@mui/icons-material/Rule'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import VaccinesIcon from '@mui/icons-material/Vaccines'
import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid'
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'
import TopicIcon from '@mui/icons-material/Topic'
import FeedbackIcon from '@mui/icons-material/Feedback'
import WarningIcon from '@mui/icons-material/Warning'
import Groups2Icon from '@mui/icons-material/Groups2'
import MedicationIcon from '@mui/icons-material/Medication'
import GradingIcon from '@mui/icons-material/Grading'
import CampaignIcon from '@mui/icons-material/Campaign'
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption'
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver'
import ColorizeIcon from '@mui/icons-material/Colorize'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact'
import DashboardIcon from '@mui/icons-material/Dashboard'
import ReceiptIcon from '@mui/icons-material/Receipt'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import SettingsIcon from '@mui/icons-material/Settings'
import SmsIcon from '@mui/icons-material/Sms'
import ImportContactsIcon from '@mui/icons-material/ImportContacts'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'
import FolderSharedIcon from '@mui/icons-material/FolderShared'
import MapIcon from '@mui/icons-material/Map'
import TvIcon from '@mui/icons-material/Tv'

const ICONS = {
  home: <HomeIcon />,
  insights: <InsightsIcon />,
  baseLocations: <LocationCityIcon />,
  event: <EventIcon />,
  eventBusy: <EventBusyIcon />,
  timer: <TimerOutlinedIcon />,
  money: <AttachMoneyIcon />,
  receiptLong: <ReceiptLongIcon />,
  roster: <InsertInvitationIcon />,
  personAdd: <PersonAddIcon />,
  speed: <SpeedIcon />,
  people: <Diversity3Icon />,
  school: <SchoolIcon />,
  dbs: <LocalPoliceIcon />,
  healthAndSafety: <HealthAndSafetyIcon />,
  tacticalLog: <DvrIcon />,
  controlRoom: <HubIcon />,
  treatment: <HotelIcon />,
  handshake: <HandshakeIcon />,
  schedule: <ScheduleIcon />,
  punchClock: <PunchClockIcon />,
  patients: <PeopleIcon />,
  organisation: <BusinessIcon />,
  dispatch: <SupervisedUserCircleIcon />,
  stats: <QueryStatsIcon />,
  car: <DirectionsCarFilledIcon />,
  vehicle: <LocalTaxiIcon />,
  carWash: <LocalCarWashIcon />,
  build: <BuildIcon />,
  inventory: <InventoryIcon />,
  checklist: <ChecklistIcon />,
  checklistRtl: <ChecklistRtlIcon />,
  noCrash: <NoCrashIcon />,
  factCheck: <FactCheckIcon />,
  fuel: <LocalGasStationIcon />,
  epcr: <MedicalInformationIcon />,
  rule: <RuleIcon />,
  imaging: <MonitorHeartIcon />,
  dops: <WorkspacePremiumIcon />,
  meds: <VaccinesIcon />,
  medsBag: <MedicationLiquidIcon />,
  risk: <CrisisAlertIcon />,
  incident: <GppMaybeIcon />,
  policy: <TopicIcon />,
  feedback: <FeedbackIcon />,
  alert: <WarningIcon />,
  meetings: <Groups2Icon />,
  pgd: <MedicationIcon />,
  sop: <GradingIcon />,
  announcement: <CampaignIcon />,
  vault: <EnhancedEncryptionIcon />,
  speakUp: <RecordVoiceOverIcon />,
  syringe: <ColorizeIcon />,
  actions: <AssignmentTurnedInIcon />,
  clients: <ConnectWithoutContactIcon />,
  financeDashboard: <DashboardIcon />,
  invoice: <ReceiptIcon />,
  quote: <RequestQuoteIcon />,
  settings: <SettingsIcon />,
  sms: <SmsIcon />,
  docs: <ImportContactsIcon />,
  support: <LiveHelpIcon />,
  task: <TaskAltIcon />,
  assignmentLate: <AssignmentLateIcon />,
  folderShared: <FolderSharedIcon />,
  sitemap: <AccountTreeIcon />,
  referral: <CardGiftcardIcon />,
  access: <AdminPanelSettingsIcon />,
  wallboard: <TvIcon />,
  map: <MapIcon />,
}

export const getNavIcon = (key) => ICONS[key] ?? <MapIcon />

export default ICONS
